module.exports = __webpack_public_path__ + "static/media/badge-check.1cb9bcf4.svg";